export default {
    disabledStyle: {
        cursor: "not-allowed",
        opacity: 0.5,
    },

    radioLabel: {
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "17px",
        color: "#262626",
    }
}